import IMAGES from 'src/commons/variables/images'
import ICONS from 'src/commons/variables/icons';

export const withAppDummys = [
    {
        id: 1,
        title: "메인",
        description: "스카우팅 정보 검색 및 지원",
        image: IMAGES.HOME.default,
        icon: ICONS.HOME.default
    },
    {
        id: 2,
        title: "검색",
        description: "선수, 구단 검색",
        image: IMAGES.SEARCH.default,
        icon: ICONS.SEARCH.default
    },
    {
        id: 3,
        title: "그라운드",
        description: "팬 참여 공간",
        image: IMAGES.GROUND.default,
        icon: ICONS.GROUND.default
    },
    {
        id: 4,
        title: "팀 프로필",
        description: "팀 정보 관리",
        image: IMAGES.TEAM_PROFILE.default,
        icon: ICONS.TEAM_PROFILE.default
    },
    {
        id: 5,
        title: "마이 프로필",
        description: "개인 정보 관리 및 홍보",
        image: IMAGES.MY_PROFILE.default,
        icon: ICONS.MY_PROFILE.default
    },
]